export default __webpack_public_path__ + "static/media/noun_logout_2035127.39e0431d.svg";